import React from "react";
import PropTypes from "prop-types";
import Modal from 'react-modal';
import FaYoutube from "react-icons/lib/fa/youtube";
import { addAllToPlaylist, cancelAddAllToPlaylist, viewOnYoutube } from '../../lib/youtube-converter';
import { isMobileOrTablet } from '../../lib/window';


const customStyles = {
  overlay: {zIndex: 10},
  content : {
    height                : '80vh',
    width                 : '80vw',
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

class PlaylistConversionFilterModal extends React.Component {
  constructor() {
    super();

    this.state = {
      modalIsOpen: false
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    // cancelAddAllToPlaylist();
    this.setState({modalIsOpen: false});
  }

  render() {
    const { canConvert } = this.props;

    return (
      <React.Fragment>
        <div className="playlist-conversion-modal">
          {canConvert && <button className="convert-playlist md" onClick={this.openModal}>Filters</button>}
          <Modal
            ariaHideApp={false}
            isOpen={this.state.modalIsOpen}
            // onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModal}
            style={customStyles}
            contentLabel="Example Modal"
            >
            <div>
              <h2>Filters Coming Soon</h2>
            </div>
          </Modal>
        </div>

        {/* --- STYLES --- */}
        <style jsx>{`
          .playlist-conversion-modal {
            display: inline-block;
            margin-left: 10px;
          }

          button {
            border: 0;
            cursor: pointer;
            font-size: 16px;
            min-width: 100px;
          }

          button.xl {
            border-radius: 5px;
            font-size: 24px;
            padding: 10px 15px;
          }

          button.cancel-conversion {

          }

          button.md {
            border-radius: 5px;
            // font-size: px;
            padding: 10px 15px;
          }

          button.convert-playlist {
            background: #346294;
            color: white;
          }

          button.view-on-youtube {
            background: red;
            color: white;
            // border-radius: 50px;
            // max-width: 100vw;
            min-height: 60px;
            margin-left: 20px;
          }

          @from-width tablet {
            .playlist-conversion-modal {

            }
          }
        `}</style>
      </React.Fragment>
    );
  }
};

export default PlaylistConversionFilterModal;



// WEBPACK FOOTER //
// ./src/components/PlaylistConversionFilterModal/PlaylistConversionFilterModal.js